import PaymentTypeEnum from '@/api/Enums/PaymentTypeEnum.js'

export default {
  methods: {
    eftPosCardTransactionPaidSuccessful(transaction) {
      return (transaction?.Action === 'SALE'
          && transaction?.Paid && transaction?.Paid === 'success'
          && transaction?.ResponseIntentResult === 'COMPLETED'
          && transaction?.ResponseIntentStatus === 'APPROVED')
        || (transaction?.Action === 'REFUND'
          && transaction?.Paid && transaction?.Paid === 'success'
          && transaction?.ResponseIntentResult === 'COMPLETED'
          && (transaction?.ResponseIntentStatus === 'DECLINED' || transaction?.ResponseIntentStatus === 'CANCELLED')
        )
    },

    eftPosCardTransactionRefundedSuccessful(transaction) {
      return transaction?.Refund && transaction?.Refund === 'success'
    },

    isEftPosEnabledTransaction(transaction) {
      return (
        (this.userIsDelivery && PaymentTypeEnum.isDeliveryCard(transaction?.PaymentType)) ||
        (!this.userIsDelivery && PaymentTypeEnum.isEftPosPaymentType(transaction?.PaymentType) && !transaction?.External)
      )
    }
  }
}
